/**
 * @file        src/lib/company.js
 * @description Issuing-company details printed on customer documents (tax
 *              invoice, voucher) and shown on the legal / contact pages. The
 *              postal ADDRESS here is only the FALLBACK — the live value comes
 *              from admin Site Settings via useCompanyInfo(); see that hook.
 *              Extracted from pages/Legal/LegalDoc.jsx (which re-exports it) so
 *              the hook can import the defaults without a circular import.
 * @author      Kinetika Labs
 * @created     2026-07-23
 * @changelog
 *   - 2026-07-23 Claude — Extracted from LegalDoc so the address becomes a single
 *                          source of truth sourced from Site Settings.
 *   - 2026-07-31 Claude — Real contact details per the client: phone is now the
 *                          published +91 886 202 5587 (was the placeholder
 *                          +91 79726 68441) and the general mailbox is
 *                          bookings@neonholidays.com (was contact@). `support`
 *                          is unchanged — the legal documents route grievances and
 *                          data-protection requests there deliberately.
 *   - 2026-07-31 Claude — Fallback address updated to the Nagpur office (was
 *                          Bavdhan, Pune). NOTE this is only the fallback: when
 *                          admin Site Settings has an address configured, that one
 *                          wins site-wide via useCompanyInfo().
 *   - 2026-09-15 Claude — `gstin` / `state` are no longer the live values, only
 *     the fallbacks: both now come from admin Site Settings via useCompanyInfo()
 *     (admin migration 056), which is what finally lets a tenant put its real
 *     GSTIN on its tax invoices. The "replace before go-live" TODO below is
 *     therefore answered by configuration, not by editing this file — and the
 *     placeholders stay deliberately neutral so an unconfigured tenant prints
 *     nothing rather than another tenant's registration.
 */
export const COMPANY = {
  name: 'Neon Holidays',
  legal: 'Neon Holidays Pvt. Ltd.',
  // Fallback address only — the live value is the one configured in admin Site
  // Settings (Site Management → Site Setting), fetched by useCompanyInfo().
  address: '47, West Park Road, near Dhantoli Garden, Dhantoli, Nagpur - 440012',
  email: 'bookings@neonholidays.com',
  phone: '+91 886 202 5587',
  support: 'support@neonholidays.com',
  web: 'www.neonholidays.com',
  jurisdiction: 'Pune, Maharashtra',
  // FALLBACKS ONLY — the live values come from admin Site Settings (Payment
  // Management → Tax Management) via useCompanyInfo(). Configure the tenant's
  // real GSTIN there; do not hardcode one here, or every tenant built from this
  // bundle prints it.
  state: 'Maharashtra',
  gstin: '—',
  pan: '—',
  registrationNo: '—',
  hsn: '—',
};
